import { render, staticRenderFns } from "./DeferredCollection.vue?vue&type=template&id=46bdbfee&scoped=true"
import script from "./DeferredCollection.vue?vue&type=script&lang=js"
export * from "./DeferredCollection.vue?vue&type=script&lang=js"
import style0 from "./DeferredCollection.vue?vue&type=style&index=0&id=46bdbfee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bdbfee",
  null
  
)

export default component.exports